import { Card, Checkbox, Flex } from '@mantine/core';
import { IColumn } from 'components/elements/table-component/table-component';
import { useFlexibleColumns } from 'hooks/use-flexible-columns';
import Text from 'mantine-components/widget/text';
import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

const ItemType = 'TABLE_SORTABLE_ITEM';

interface DragItem {
  index: number;
  type: string;
}

interface UniskaiPivotItemProps<T> {
  index: number;
  item: IColumn<T>;
}

export default function UniskaiPivotItem<T>(props: UniskaiPivotItemProps<T>) {
  const { index, item } = props;
  const ref = React.useRef(null);

  const { setColumnHidden, moveItem } = useFlexibleColumns();

  // Dragging logic
  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Dropping logic
  const [, drop] = useDrop({
    accept: ItemType,
    hover: (draggedItem: DragItem) => {
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  drag(drop(ref));

  return (
    <Card
      ref={ref}
      withBorder
      shadow="xs"
      radius="md"
      style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
      my="sm"
    >
      <Flex gap={8} justify="space-between">
        <Text> {item.header?.toString()}</Text>
        <Checkbox
          checked={item.isHidden}
          label="Hide"
          onChange={(event) => {
            setColumnHidden(item, event.currentTarget.checked);
          }}
        />
      </Flex>
    </Card>
  );
}
